enum BreakPointsEnum {
    _wide = "1440px",
    _desktop = "1024px",
    _mobile = "700px",
}

export default BreakPointsEnum;
